import { Tooltip } from '@mui/material';
import { AUTOMATION_SOURCE } from 'utils/constants';
import AlisaIcon from 'assets/icons/AlisaIcon';
import UserModifiedIcon from 'assets/icons/UserModifiedIcon';
import OcrTextScanIcon from 'components/icons/OcrTextScanIcon';
import styles from './FieldSourceIcon.module.css';

function FieldSourceIcon({ source }) {
    if (!source) return null;

    const isAlisa = source === AUTOMATION_SOURCE.AI_OCR;
    const isUser = source === 'user';

    if (source === AUTOMATION_SOURCE.CONDOR) {
        return (
            <Tooltip title="Verified by OCR (Condor)" placement="top">
                <span className={styles.icon}>
                    <OcrTextScanIcon />
                </span>
            </Tooltip>
        );
    }

    return (
        <Tooltip title={isUser ? 'User modified' : 'AI suggestion'} placement="top">
            <span className={styles.icon}>{isAlisa ? <AlisaIcon /> : <UserModifiedIcon />}</span>
        </Tooltip>
    );
}

export default FieldSourceIcon;
